var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_vm._v(" "),_c('router-view',{attrs:{"name":"footer"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"busy"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"notification"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layouts/Login.vue?vue&type=template&id=1b03f85c
// module id = null
// module chunks = 